import { onAuthErrorRedirect, queryDefaults } from "@nimit9/signet-lib/api/query-client"
import { QueryClient } from "@tanstack/react-query"

// Signet's defaults: 5-minute staleTime; retry up to 2× only for network
// errors, 5xx, 408 and 429 (never AuthError or other 4xx); back off 1s, 2s, 4s…
// capped at 30s, or wait the server's Retry-After. Mutations never retry.
export const queryClient = new QueryClient({ defaultOptions: queryDefaults() })

// Global 401 handler — redirect to /login (SPA route) when the session expires.
onAuthErrorRedirect(queryClient, () => {
  window.location.href = "/login"
})

/** How long the tab must have been in the background before returning refreshes data. */
export const REFRESH_AFTER_AWAY_MS = 60_000

/**
 * Changes made elsewhere (Claude via MCP, a partner on another device) don't push
 * to this browser, and queries stay fresh for 5 minutes, so an open tab showed old
 * numbers (UAT CF-10). When the person comes back after a minute or more away,
 * refetch what's on screen. Only active queries refetch, so it's one page's worth.
 */
export function refreshOnReturn(
  client: Pick<QueryClient, "invalidateQueries">,
  doc: Pick<Document, "visibilityState" | "addEventListener"> = document,
  now: () => number = Date.now,
) {
  let hiddenAt: number | null = null
  doc.addEventListener("visibilitychange", () => {
    if (doc.visibilityState === "hidden") hiddenAt = now()
    else if (hiddenAt !== null && now() - hiddenAt >= REFRESH_AFTER_AWAY_MS) {
      hiddenAt = null
      void client.invalidateQueries()
    }
  })
}

if (typeof document !== "undefined") refreshOnReturn(queryClient)
